import { useEngagementContext } from './engagement.provider';
import { IFeedbackData, ThumbOptions } from '@honeybook/engagement';
import { trackError } from '@honeybook/utils';
import { useLogger } from '@honeybook/core-react';

interface UseFeedbackResult {
    sendFeedback: (
        objectId: string,
        feedbackType: 'thumbs' | 'free_text',
        feedbackValue: ThumbOptions | string,
        entityName?: string
    ) => Promise<void>;
}

export const useFeedback = (): UseFeedbackResult => {
    const { feedbackService } = useEngagementContext();
    const logger = useLogger();

    const sendFeedback = async (
        objectId: string,
        feedbackType: 'thumbs' | 'free_text',
        feedbackValue: ThumbOptions | string,
        entityName: string
    ) => {
        try {
            const feedbackData: IFeedbackData = {
                feedback_type: feedbackType,
                feedback_value: feedbackValue
            };

            await feedbackService.sendFeedback(
                objectId,
                entityName,
                feedbackData
            );
        } catch (error) {
            trackError({
                error,
                logger,
                message: 'Error sending feedback',
                context: { objectId, feedbackType, feedbackValue }
            });
        }
    };

    return { sendFeedback };
};
